import { ImageObject } from '@packages/image/lib/types';
import React from 'react';
import SelectableCard from '../../Components/SelectableCard';

interface SkuCardProps {
    item: {
        id: number;
        name: string;
        image?: string | ImageObject;
        preview_photo?: string | ImageObject;
    };
}

export function SkuCard(props: SkuCardProps & { [key: string]: any }) {
    const { item, ...rest } = props;
    const { image, preview_photo } = item;
    const image$: any = image || preview_photo;

    return (
        <SelectableCard
            showImage
            id={item.id}
            title={item.name}
            selectionType={'checkbox'}
            image={image$ ? image$.thumbnail_path : null}
            {...rest}
        />
    );
}
